import Vue from 'vue'

const state = {
  search: {
    'advanced': []
  }
}

// getters
const getters = {
  search: state => key => Vue.lodash.orderBy(state.search[key], ['timestamp'], ['desc'])
}

const mutations = {
  addSearch (state, payload) {
    // Get position of history search value
    let history = payload.params.history
    let pos = state.search[payload.params.key].findIndex(i => i.search === history.search)
    if (pos > -1) {
      // Adjust timestamp
      state.search[payload.params.key][pos].timestamp = history.timestamp
    } else {
      // history is not in detailSearch
      state.search[payload.params.key].push(history)
    }
  },
  deleteSearch (state, payload) {
    state.search[payload.params.key].splice(payload.params.history.index, 1)
  },
  clearSearch (state, payload) {
    state.search[payload.params.key] = []
  }
}

// actions
const actions = {
  addSearch: ({ commit }, params) => {
    commit({ type: 'addSearch', params })
  },
  deleteSearch: ({ commit }, params) => {
    commit({ type: 'deleteSearch', params })
  },
  clearSearch: ({ commit }, params) => {
    commit({ type: 'clearSearch', params })
  }

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
